import React from "react";
import "./PricingMfd.css";

const PricingMfd = () => {
    const mfdCrmFeatures = [
        "Investor lifecycle & relationship management",
        "WealthElite integration",
        "Intuitive dashboard",
        "RM/employee/branch/broker activity monitoring",
        "Smart lead assignment & prospect pipeline",
        "Follow-up reminders, tasks & engagement tracking",
        "Document vault & investor profile history",
        "Meeting logs, notes & interaction timeline",
        "Custom reports & performance insights",
        "Multi-user role & access management",
        "Mobile app for field teams & RMs",
    ];

    const callCrmFeatures = [
        "Everything included in MFD CRM",
        "Automatic business call tracking",
        "Call recording & conversation history",
        "Lead-wise call activity timeline",
        "Daily employee productivity reports",
        "Call analytics & performance monitoring",
        "Team calling activity dashboard",
        "Missed follow-up & idle time tracking",
        "Calling insights for better investor engagement",
        "Mobile app with integrated call monitoring",
    ];

    return (
        <section className="pricing-mfd-section" id="pricing">
            <div className="pricing-mfd-wrapper">
                {/* Pricing Section Heading */}
                <div className="pricing-mfd-header">
                    <div className="pricing-mfd-kicker">
                        <span className="pricing-mfd-kicker-line"></span>
                        <span>SIMPLE, TRANSPARENT PRICING</span>
                    </div>

                    <h2 className="pricing-mfd-title">
                        One Plan. Built for
                        <span>Growing MFDs</span>
                    </h2>
                </div>

                {/* Pricing Cards */}
                <div className="pricing-mfd-container">
                    {/* MFD CRM CARD */}
                    <article className="pricing-plan-card pricing-plan-card-light">
                        <div className="pricing-plan-content">
                            <p className="pricing-plan-name">SALES NINJA MFD CRM</p>

                            <div className="pricing-price-row">
                                <span className="pricing-price">₹9,500</span>

                                <span className="pricing-duration">/user/year</span>
                            </div>

                            <p className="pricing-description">
                                Complete business management platform for Mutual Fund Distributors
                            </p>

                            <div className="pricing-upfront-box">
                                <span>Upfront One-time Cost:</span>
                                <strong>₹20,000</strong>
                            </div>

                            <div className="pricing-feature-section">
                                <h3 className="pricing-feature-heading">
                                    <span className="pricing-heading-check">✓</span>
                                    <span>Features:</span>
                                </h3>

                                <ul className="pricing-feature-list">
                                    {mfdCrmFeatures.map((feature) => (
                                        <li key={feature}>
                                            <span className="pricing-check-icon">✓</span>

                                            <span>{feature}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        <a
                            href="/#contactus"
                            className="pricing-action-button pricing-action-button-outline"
                            aria-label="Get started with Sales Ninja MFD CRM"
                        >
                            Get Started
                        </a>
                    </article>

                    {/* MFD CRM + CALL CRM CARD */}
                    <article className="pricing-plan-card pricing-plan-card-highlight">
                        <div className="pricing-recommended-badge">Recommended</div>

                        <div className="pricing-plan-content">
                            <p className="pricing-plan-name">SALES NINJA MFD CRM + CALL CRM</p>

                            <div className="pricing-price-row">
                                <span className="pricing-price">₹14,400</span>

                                <span className="pricing-duration">/user/year</span>
                            </div>

                            <p className="pricing-description">
                                MFD CRM combined with advanced calling productivity &amp; monitoring tools
                            </p>

                            <div className="pricing-upfront-box">
                                <span>Upfront One-time Cost:</span>
                                <strong>₹20,000</strong>
                            </div>

                            <div className="pricing-feature-section">
                                <h3 className="pricing-feature-heading">
                                    <span className="pricing-heading-check">✓</span>
                                    <span>Features:</span>
                                </h3>

                                <ul className="pricing-feature-list">
                                    {callCrmFeatures.map((feature) => (
                                        <li key={feature}>
                                            <span className="pricing-check-icon">✓</span>

                                            <span>{feature}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        <a
                            href="/#contactus"
                            className="pricing-action-button pricing-action-button-filled"
                            aria-label="Get started with Sales Ninja MFD CRM and Call CRM"
                        >
                            Get Started
                        </a>
                    </article>
                </div>
            </div>
        </section>
    );
};

export default PricingMfd;
